import getGifTrendingResults from '../services/getGifTrendingResults';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import GifPickerViewState from '../store/schema/GifPickerViewState';
import { BingGifValue } from '../services/getGifSearchResults';

export default async function createGifPickerViewState(): Promise<GifPickerViewState> {
    let gifTrendingResults: BingGifValue[];
    try {
        gifTrendingResults = await getGifTrendingResults();
    } catch {
        gifTrendingResults = null;
    }

    const gifPickerViewState = {
        culture: getUserConfiguration().SessionSettings.UserCulture,
        gifTrending: gifTrendingResults,
    };
    return gifPickerViewState;
}
